import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatPaginatorIntlEn } from '@core/adapters/paginator';
import { DEFAULT_MASK_CONFIG, MASK_CONFIG } from '@core/configs/input.config';
import { AuthService } from '@core/services/auth.service';
import { ClipboardService } from '@core/services/clipboard.service';
import { EncryptionService } from '@core/services/encryption.service';
import { FileManagementService } from '@core/services/file-management.service';
import { HttpService } from '@core/services/http.service';
import { PermissionService } from '@core/services/permission.service';
import { QueryParamsMapperService } from '@core/services/query-params-mapper.service';
import { SplashScreenService } from '@core/services/splash-screen.service';
import { ErrorInterceptor } from 'app/core/interceptors/http.interceptor';
import { JwtInterceptor } from 'app/core/interceptors/jwt.interceptor';
import { UnauthorizedInterceptor } from 'app/core/interceptors/unauthorized.interceptor';

export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    HttpService,
    AuthService,
    PermissionService,
    FileManagementService,
    ClipboardService,
    QueryParamsMapperService,
    EncryptionService,
    SplashScreenService,
    { provide: MASK_CONFIG, useValue: DEFAULT_MASK_CONFIG },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'fixed' } as MatFormFieldDefaultOptions,
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['app-snackbar', 'app-mt-100'],
      } as MatSnackBarConfig,
    },
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginatorIntlEn,
    },
  ]);
}
